export default __webpack_public_path__ + "static/media/alex7.30aba1bd.jpg";